import { SecurityGuard } from "@duosoftbg/nacid-components";
import React from "react";
import SignedDocumentResultPage from "../views/components/services/common/signature/SignedDocumentResultPage";

export const signatureSpecificRoutes = [
  {
    path: "/my-applications/signed-document-details",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <SignedDocumentResultPage />
      </SecurityGuard>
    ),
  },
];
